<template>
  <div>
    <vue-modal :open="open">
    <div class="bax-modal-content bax-modal-icon-content text-center">
      <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
        <i class="icon-exclamation"></i>
      </div>
      <h2>No system stability exists for this order</h2>
      <p>Go <strong>Back</strong> to review order as per Baxter stability data.</p>
      <p><strong>Continue</strong> if stability agreement is in place.</p>
      <div class="bax-modal-action-items">
        <ul class="d-md-flex justify-content-center">
          <li>
            <a href="#" class="bax-btn bax-btn-gray mt-3 mt-md-0" @click.prevent="stabilityChoice_back">Back</a>
          </li>
          <li>
            <a href="#" class="bax-btn bax-btn-orange mt-3 mt-md-0" @click.prevent="stabilityChoice_submit">Continue</a>
          </li>
        </ul>
      </div>
    </div>
    </vue-modal>
  </div>
</template>


<script>

export default {
  name: 'StabilityErrorModal',
  props: {
    open: {
      type: Boolean,
    },
    drugs: {
      type: Array,
    },
    dosages: {
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    stabilityChoice_back() {
      this.$emit('stabilityReview');
    },
    stabilityChoice_submit() {
      this.$emit('stabilitySubmit');
    },
  },
};
</script>
